import React from 'react'
import PropTypes from 'prop-types'

import { ArrowLeft, ArrowRight } from '../Svg'
import { noop } from '../../lib/utils/common'

export const Arrows = ({ onNextClick, onPreviusClick }) => {
  return (
    <React.Fragment>
      <div
        className='PhotoCarousel-arrow PhotoCarousel-arrow--left'
        onClick={onPreviusClick}
        role='button'
        onKeyDown={noop}
        tabIndex='0'
      >
        <ArrowLeft className='PhotoCarousel-icon' />
      </div>
      <div
        className='PhotoCarousel-arrow PhotoCarousel-arrow--right'
        onClick={onNextClick}
        role='button'
        onKeyDown={noop}
        tabIndex='0'
      >
        <ArrowRight className='PhotoCarousel-icon' />
      </div>
    </React.Fragment>
  )
}

Arrows.propTypes = {
  onNextClick: PropTypes.func,
  onPreviusClick: PropTypes.func
}
